import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/dasha-calculator/page.tsx");
